import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import { slug } from '../common';
import { components } from '@glowingblue-orell-thalia-common';
import extendLoginSignupModal from './extenders/extendLoginSignupModal';

app.initializers.add(slug, () => {
	extendLoginSignupModal();

	// Mobile tour assets
	override(components.MobileTourCard.prototype, 'getAssetDir', () => {
		return `/assets/extensions/${slug}/mobile_tour`;
	});
	// Footer links
	override(components.CustomFooter.prototype, 'getFooterLinks', () => {
		return [
			{ href: '/p/5-rezensionsleitfaden', label: 'Bewertungsleitfaden' },
			{
				href: '/p/9-in-unseren-faq-geben-wir-dir-antworten-auf-h-ufig-gestellte-fragen',
				label: 'FAQ',
			},
			{ href: '/p/8-netiquette', label: 'Netiquette' },
			{ href: '/p/7-datenschutz', label: 'Datenschutz' },
			{ href: '/p/4-impressum', label: 'Impressum' },
			{ href: '/p/6-community-nutzungsbedingungen', label: 'Nutzungsbedingungen' },
			{ href: '/p/10-illegale-inhalte-melden', label: 'Illegale Inhalte melden' },
		];
	});

	override(components.CustomFooter.prototype, 'getInstagramUrl', () => {
		return 'https://www.instagram.com/thalia_buchhandlungen';
	});
});
